// AuthService.js

const USERS = JSON.parse(process.env.REACT_APP_USERS || '[]');
console.log("USERS", USERS)
const login = async (userData) => {
  const { username, password } = userData;

  await new Promise(resolve => setTimeout(resolve, 1000));  // Simular un delay

  // Validación especial para el usuario admin por separado
  if (
    username === process.env.REACT_APP_DEFAULT_USER &&
    password === process.env.REACT_APP_DEFAULT_PASS
  ) {
    const defaultUser = {
      accessToken: "fakeToken123456789",
      user: {
        name: "Usuario Ejemplo",
        username,
      },
    };
    localStorage.setItem('user', JSON.stringify(defaultUser));
    return defaultUser;
  }

  // Buscar en la lista de usuarios definidos
  const matchedUser = USERS.find(
    user => user.username === username && user.password === password
  );

  if (matchedUser) {
    const session = {
      accessToken: "fakeToken123456789",
      user: {
        name: matchedUser.name,
        username: matchedUser.username,
      },
    };
    localStorage.setItem('user', JSON.stringify(session));
    return session;
  }

  throw new Error('Credenciales incorrectas');
};

const logout = () => {
  localStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

export { login, logout, getCurrentUser };
